export const internalTeamRoutesEnum = {
  root: {
    name: 'internal team root',
    path: '/internal-team',
    title: 'header.internalTeam',
    icon: 'mdi-account-group-outline',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Internal Team`,
      shouldHaveInternalTeamMode: true,
      // The Overview tab hosts the onboarding timeline + Resume CTA, so it
      // must stay reachable even while the journey is incomplete — only the
      // onboarding-journey redirect guard (router/index.ts) is exempted
      // here, not the internal-team-mode gate above.
      allowDuringOnboarding: true,
    },
  },
  onboarding: {
    name: 'onboarding journey wizard',
    path: '/internal-team/onboarding',
    meta: {
      requiresAuth: true,
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Onboarding`,
      shouldHaveOnboardingJourney: true,
      allowDuringOnboarding: true,
    },
  },
};
